import React, { useEffect, useState } from "react";
import { Pencil } from "lucide-react";
import { Trash2 } from "lucide-react";
import { Plus } from "lucide-react";
import messageIcon from "../../../images/messageIcon.png";
import emailIcon from "../../../images/emailIcon.png";
import whatsaapIcon from "../../../images/whatsaapIcon.png";
import Selectbox from "../../../components/Common/Selectbox";
import { APIUtility } from "../../../Api";
import { addToast } from "../../../Redux/CommonSlice/toastSlice";
import { useDispatch } from "react-redux";
import ConfrimModal from "../../../Modal/ConfrimModal";
import Loader from "../../../components/Common/Loader";
import NoData from "../../../components/Common/NoData";
import Checkbox from "../../../components/Common/Checkbox";
import Pagination from "../../../components/Common/Pagination";


function NotificationComponent({ permissions }) {
  const [selected, setSelected] = useState("All");
  const [configurations, setConfigurations] = useState([]);
  const [newConfig, setNewConfig] = useState(null);
  const [editingIndex, setEditingIndex] = useState(null);
  const [personName, setPersonName] = useState([]);
  const [notificationData, setNotificationData] = useState([]);
  const [editRowId, setEditRowId] = useState(null);
  const [editData, setEditData] = useState(null);
  const [confrimModalShow, setConfrimModalShow] = useState(false);
  const [notificationConfigId, setNotificationConfigId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationData, setPaginationData] = useState({});
  const dispatch = useDispatch();

  const handleAddNewConfig = () => {
    setNewConfig({
      message: "",
      channel: [],
      notifyVia: "",
      active_status: false
    });
    setPersonName([]);
    setEditingIndex(null);
  };

  const getNotificationData = async (page) => {
    setIsLoading(true);
    try {
      const res = await APIUtility.GetNotificationConfig({
        channel: selected == "All" ? "" : selected.toLowerCase(),
        page: page ? page : currentPage,
      });
      if (res.status == 200) {
        const data = res.data;
        setPaginationData(data.pagination_details);
        setNotificationData(data?.serialized_data);

        setIsLoading(false);
      } else {
        setNotificationData([]);
      }
    } catch (error) {
      setIsLoading(false);
      setNotificationData([]);
    }
  };

  useEffect(() => {
    getNotificationData();
  }, []);
  useEffect(() => {
    getNotificationData();
  }, [selected]);

  const handleSaveNewConfig = async () => {
    const data = {
      message: newConfig.name,
      channel: newConfig.channel[0]?.value.toLowerCase(),
      alert_email: newConfig.channel[0]?.value.toLowerCase().includes("email")
        ? newConfig.notifyVia
        : "",
      alert_sms:
        newConfig.channel[0]?.value.includes("WhatsApp") ||
          newConfig.channel[0]?.value.includes("sms")
          ? newConfig.notifyVia
          : "",
      active_status: newConfig?.active_status
    };

    try {
      if (isFormFilled()) {
        const response = await APIUtility.AddNotificationConfig(data);

        if (response.status === 200 || response.status === 201) {
          getNotificationData();

          setNewConfig(null);
          setEditingIndex(null);
        } else {
          console.error("Failed to add new configuration:", response);
          alert(
            "Failed to add new configuration. Please Fill Configuration Details."
          );
        }
      } else {
        dispatch(
          addToast({
            message: "Fill All Required Fields!",
            isError: true,
          })
        );
      }
    } catch (error) {
      console.error("Error adding new configuration:", error); // Log the error
      alert(
        "An error occurred while adding the configuration. Please try again."
      );
    }
  };

  const handleDeleteConfig = async () => {
    try {
      const res = await APIUtility.DeleteNotificationConfig({
        id: notificationConfigId,
      });
      if (res.status == 204) {
        setConfrimModalShow(false);
        getNotificationData();
        // setUserId(null);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  const isFormFilled = () => {
    if (
      !newConfig?.name ||
      newConfig?.channel?.length === 0 ||
      !newConfig?.notifyVia
    ) {
      return false;
    }

    if (
      newConfig?.channel[0]?.value.includes("WhatsApp") ||
      newConfig?.channel[0]?.value.includes("sms")
    ) {
      const phoneRegex = /^[0-9]{10,}$/;
      if (!phoneRegex.test(newConfig.notifyVia)) {
        setErrorMessage("Enter 10 digit Number Only ");
        setTimeout(() => {
          setErrorMessage(null);
        }, 5000);
      }

      return phoneRegex.test(newConfig.notifyVia);
    }

    if (newConfig?.channel[0]?.value.includes("Email")) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(newConfig.notifyVia)) {
        setErrorMessage("Enter Valide email address ");

        setTimeout(() => {
          setErrorMessage(null);
        }, 5000);
      }
      return emailRegex.test(newConfig.notifyVia);
    }

    return true;
  };

  const classImg = "w-[25px] h-[25px]";

  const optionData = [
    {
      label: "WhatsApp",
      value: "WhatsApp",
      prefix: (
        <img
          src={require("../../../images/whatsaapIcon.png")}
          className={classImg}
        />
      ),
    },
    {
      label: "Email",
      value: "Email",
      prefix: (
        <img
          src={require("../../../images/emailIcon.png")}
          className={classImg}
        />
      ),
    },
    {
      label: "Message",
      value: "sms",
      prefix: (
        <img
          src={require("../../../images/messageIcon.png")}
          className={classImg}
        />
      ),
    },
  ];

  const TableColumn = [
    {
      name: "Configuration Name",
      className: "w-[20%]",
    },
    {
      name: "Notification Type",
      className: "w-[20%]",
    },
    {
      name: "Notify Via (Phone No./Email)",
      className: "w-[15%]",
    },
    {
      name: "Active Status",
      className: "w-[11%]",
    },
    {
      name: "Action",
      className: "w-[15%]",
    },
  ];


  const UpdateAlertNotification = async (id) => {
    const data = {
      id: editData.alert_noti_id,
      alert_sms:
        editData.channel == "whatsapp" || editData.channel == "sms"
          ? editData.alert_sms
          : "",
      alert_email: editData.channel == "email" ? editData.alert_email : "",
      message: editData.message,
      channel: editData.channel == "message" ? "sms" : editData.channel,
      active_status: editData?.active_status
    };
    const phoneRegex = /^[0-9]{10,}$/;
    if (editData.channel == "whatsapp" || editData.channel == "sms") {
      if (!phoneRegex.test(editData.alert_sms)) {
        setErrorMessage("Enter 10 digit Number Only ");
        setTimeout(() => {
          setErrorMessage(null);
        }, 5000);
        return null;
      }
    }
    if (editData.channel == "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(editData.alert_email)) {
        setErrorMessage("Enter Valid email address ");

        setTimeout(() => {
          setErrorMessage(null);
        }, 5000);
        return null;
      }
    }


    try {
      const res = await APIUtility.UpdateNotificationConfig(data);
      if (res.status == 201) {
        dispatch(
          addToast({
            message: "Alert Configuration Updated Successfully",
            isError: false,
          })
        );
        setEditData(null);
        getNotificationData();
      }
    } catch (error) {
      console.log(error, "error");
      dispatch(
        addToast({
          message: error.message || "Failed to update Alert Configuration",
          isError: true,
        })
      );
    }
  };

  return (
    <div className="w-full h-auto gap-2.5 font-roboto">
      <div className="flex justify-between items-center w-full h-11 mb-[10px]">
        <p className="py-5 text-black/50 text-lg m-0 font-semibold font-['Roboto']">
          Notification Setting
        </p>
        <div className="flex w-auto gap-2.5 h-11">
          <div className="flex bg-white w-auto h-11 rounded-md p-1 py-1">
            <p
              className={`m-0 font-bold font-['Roboto'] text-center cursor-default flex items-center px-6 py-2 rounded-md ${selected === "All" ? "bg-[#DEFEDC]" : ""
                }`}
              onClick={() => setSelected("All")}
            >
              All
            </p>
            <p
              className={`m-0 font-bold font-['Roboto'] text-center cursor-default flex items-center px-6 py-2 rounded-md ${selected === "WhatsApp" ? "bg-[#DEFEDC]" : ""
                }`}
              onClick={() => setSelected("WhatsApp")}
            >
              <img src={whatsaapIcon} className="mr-2 w-[19px] h-[19px]" />{" "}
              WhatsApp
            </p>
            <p
              className={`m-0 font-bold font-['Roboto'] text-center cursor-default flex items-center px-6 py-2 rounded-md ${selected === "Email" ? "bg-[#DEFEDC]" : ""
                }`}
              onClick={() => setSelected("Email")}
            >
              <img src={emailIcon} className="mr-2 w-[19px] h-[19px]" /> Email
            </p>
            <p
              className={`m-0 font-bold font-['Roboto'] text-center cursor-default flex items-center px-6 py-2 rounded-md ${selected === "sms" ? "bg-[#DEFEDC]" : ""
                }`}
              onClick={() => setSelected("sms")}
            >
              <img src={messageIcon} className="mr-2 w-[19px] h-[19px]" />{" "}
              Message
            </p>
          </div>
          {
            permissions?.notification_add_button && <button
              className="text-white font-medium font-['Roboto'] cursor-pointer bg-green-500 px-3.5 py-3 rounded-[3px] h-11 gap-2 flex items-center"
              onClick={handleAddNewConfig}
            >
              <Plus color="#FFFFFF" />
              <span>New Configuration</span>
            </button>
          }

        </div>
      </div>
      <div>
        <div className="h-notificationtable_h overflow-y-scroll hideScrollBar">
          <table className="w-full relative border-collapse bg-white rounded-md">
            <thead className="w-full sticky top-0 z-20 bg-white">
              <tr>
                {TableColumn.map((item, i) => {
                  if ((!permissions?.notification_edit_button || !permissions?.notification_delete_button) && item.name == 'Action') {

                  } else {

                    return (
                      <th
                        key={i}
                        className={`h-full sticky bg-white top-0 text-left border-r border-black/10 gap-2.5 text-black/50 font-medium font-['Roboto'] ${item.className}`}
                      >
                        <div className="flex justify-center items-center gap-[10px] border-b-[2px] border-[#D3D3D3] p-[10px] whitespace-nowrap">
                          {item.name}
                        </div>
                      </th>
                    );
                  }
                })}
              </tr>
            </thead>
            <tbody>
              {newConfig && (
                <tr className="h-auto border-b border-black/10 text-lg">
                  <td className="h-full border-r border-black/10 px-2 py-1 gap-2.5">
                    <input
                      required
                      type="text"
                      value={newConfig.name}
                      onChange={(e) =>
                        setNewConfig({ ...newConfig, name: e.target.value })
                      }
                      placeholder="Enter Configuration Name"
                      className="w-full h-auto outline-none rounded-md p-2 gap-2.5 border border-black/20 text-base font-medium font-['Roboto']"
                    />
                  </td>
                  <td className="h-full border-r border-black/10 px-2 py-1 gap-2.5">
                    <Selectbox
                      data={optionData}
                      SelectClass={"!h-[41.6px]"}
                      onSelect={(value) => {
                        setNewConfig({ ...newConfig, channel: value });
                      }}
                      placeholder="Select Notification Type"
                    />
                  </td>
                  <td className="h-full border-r border-black/10 px-2 py-1 gap-2.5">
                    <input
                      required
                      type="text"
                      value={newConfig.notifyVia}
                      onChange={(e) => {
                        setNewConfig({
                          ...newConfig,
                          notifyVia: e.target.value,
                        });
                        setErrorMessage(null);
                      }}
                      placeholder="Enter Phone No./Email"
                      className="w-full h-auto outline-none rounded-md p-2 gap-2.5 border border-black/20 text-base font-medium font-['Roboto']"
                    />
                    {ErrorMessage && (
                      <p className=" m-0 text-red-600 text-[10px] absolute bottom-[-10px]">
                        {ErrorMessage}
                      </p>
                    )}
                  </td>
                  <td className="h-full border-r border-black/10 px-3 py-2 gap-2.5 text-center text-[17px] leading-7">
                    <div className="flex items-center justify-center gap-2.5 h-full">
                      <Checkbox
                        checked={false}
                        onChange={(value) => {
                          setNewConfig({ ...newConfig, active_status: value })
                        }}
                        labelText={"Active"}
                        classNames="text-base font-medium font-['Roboto']"
                        labelClassName="!text-black select-none"
                      />
                    </div>
                  </td>
                  <td className="h-full px-3 py-2 gap-2.5 flex justify-center items-center">
                    <div className="w-full flex items-center gap-2">
                      <button
                        className={`text-white cursor-pointer border w-1/2 h-[45px] rounded-md ${true ? "bg-[#4DB748]" : "bg-[#4DB7484D]"
                          }`}
                        onClick={() => handleSaveNewConfig()}
                      >
                        {editingIndex !== null ? "Update" : "Add"}
                      </button>
                      <button
                        className="w-1/2 h-[45px] rounded bg-white border-2 text-black"
                        onClick={() => setNewConfig(null)}
                      >
                        Cancel
                      </button>
                    </div>
                  </td>
                </tr>
              )}
              {isLoading ? (
                <tr>
                  <td className="h-[500px] w-full" colSpan={5}>
                    <div className="w-full h-full flex items-center justify-center">
                      <Loader />
                    </div>
                  </td>
                </tr>
              ) : !notificationData || notificationData.length === 0 ? (
                <tr>
                  <td className="h-[500px] w-full" colSpan={5}>
                    <NoData text={"No Notification Configuration Added"} />
                  </td>
                </tr>
              ) : (
                notificationData?.map((config, index) => {
                  const filterdata = optionData.filter((x) =>
                    x.value
                      ?.toLowerCase()
                      .includes(config?.channel?.toLowerCase())
                  )[0];

                  return (
                    <tr
                      key={index}
                      className="h-auto border-b border-black/10 text-lg"
                    >
                      <td className="h-full border-r border-black/10 px-2 py-1 gap-2.5 text-center text-black text-[17px] leading-7 font-medium font-['Roboto']">
                        {editData &&
                          config.alert_noti_id == editData.alert_noti_id ? (
                          <input
                            type="text"
                            placeholder={config.message}
                            value={editData.message}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                message: e.target.value,
                              })
                            }
                            className="text-black w-full h-[41.6px] outline-none rounded-md p-2 gap-2.5 border border-black/20 text-[17px] leading-7 font-medium font-['Roboto']"
                          />
                        ) : (
                          <div className="w-full text-left pl-5">
                            {config.message}
                          </div>
                        )}
                      </td>

                      <td className="h-full border-r capitalize border-black/10 px-2 py-1 items-center gap-2.5 text-black text-[17px] leading-7 font-medium font-['Roboto']">
                        {editData &&
                          config.alert_noti_id == editData.alert_noti_id ? (
                          <Selectbox
                            data={optionData}
                            SelectClass={"!h-[41.6px]"}
                            defaultValue={optionData.filter(
                              (x) => x.value.toLowerCase() == editData.channel
                            )}
                            onSelect={(value) => {
                              setEditData({
                                ...editData,
                                channel: value[0].value.toLowerCase(),
                              });
                            }}
                            placeholder="Select Notification Type"
                          />
                        ) : (
                          <div className="w-full items-center justify-center text-left pl-5">
                            <span className="flex  gap-2.5 ">
                              {filterdata?.prefix}
                              {config.channel == "sms"
                                ? "Message"
                                : config.channel == "whatsapp"
                                  ? "WhatsApp"
                                  : config.channel}
                            </span>
                          </div>
                        )}
                      </td>

                      <td className="h-full border-r border-black/10 px-2 py-1 gap-2.5 text-center font-medium text-[17px] leading-7">
                        {editData &&
                          config.alert_noti_id == editData.alert_noti_id ? (
                          <div className="relative">
                            <input
                              required
                              type="text"
                              value={
                                editData.channel == "whatsapp" ||
                                  editData.channel == "sms"
                                  ? editData.alert_sms
                                  : editData.alert_email
                              }
                              onChange={(e) => {
                                const keyFields =
                                  editData.channel == "whatsapp" ||
                                    editData.channel == "sms"
                                    ? "alert_sms"
                                    : "alert_email";

                                setEditData({
                                  ...editData,
                                  [keyFields]: e.target.value,
                                });
                              }}
                              placeholder="Enter Phone No./Email"
                              className="w-full h-[41.6px] outline-none rounded-md p-2 gap-2.5 border border-black/20 text-[17px] leading-7 font-medium font-['Roboto']"
                            />
                            {ErrorMessage && (
                              <p className=" m-0 text-red-600 text-[10px] absolute bottom-[-20px]">
                                {ErrorMessage}
                              </p>
                            )}
                          </div>
                        ) : (
                          <div className="w-full text-left pl-5">
                            <span className="flex gap-2.5">
                              {filterdata?.prefix}
                              {config?.channel === "email"
                                ? config?.alert_email
                                : config?.alert_sms}
                            </span>
                          </div>
                        )}
                      </td>

                      <td className="h-full border-r border-black/10 px-3 py-2 gap-2.5 text-center text-[17px] leading-7">

                        <div className={`flex items-center justify-center gap-2.5 h-full ${editData &&
                          config.alert_noti_id == editData.alert_noti_id ? ' pointer-events-auto opacity-100' : ' pointer-events-none opacity-60'}`}>
                          <Checkbox
                            checked={config?.active_status}
                            onChange={(value) => {
                              setEditData({
                                ...editData,
                                active_status: value,
                              });
                            }}
                            labelText={"Active"}
                            classNames="text-base font-medium font-['Roboto']"
                            labelClassName="!text-black select-none"
                          />
                        </div>
                      </td>
                      {
                        (permissions?.notification_edit_button || permissions?.notification_delete_button) && <td className="h-full px-3 py-2 gap-2.5 flex justify-center items-center">
                          {editData &&
                            config.alert_noti_id == editData.alert_noti_id ? (
                            <div className="w-full flex items-center gap-2">
                              <button
                                className="border bg-customGreen text-white cursor-pointer w-1/2 h-[45px] rounded-md"
                                onClick={() =>
                                  UpdateAlertNotification(config.alert_media_id)
                                }
                              >
                                Update
                              </button>
                              <button
                                className="p-2 rounded bg-white border-2 text-black h-[45px] w-1/2"
                                onClick={() => {
                                  setEditData(null);
                                }}
                              >
                                Cancel
                              </button>
                            </div>
                          ) : (
                            <div className="flex justify-center items-center gap-2.5">

                              {
                                permissions?.notification_edit_button && <button
                                  className="text-[#4DB748] cursor-pointer bg-[#EDF9ED] p-2.5 gap-2.5 rounded-md h-10 w-10"
                                  onClick={() => {
                                    setEditData(config);
                                  }}
                                >
                                  <Pencil size={20} />
                                </button>
                              }
                              {
                                permissions?.notification_delete_button && <button
                                  className="text-[#D92D20] cursor-pointer bg-[#FEF3F2] p-2.5 gap-2.5 rounded-md h-10 w-10"
                                  onClick={() => {
                                    setNotificationConfigId(config.alert_noti_id);
                                    setConfrimModalShow(true);
                                  }}
                                >
                                  <Trash2 size={20} />
                                </button>
                              }


                            </div>
                          )}
                        </td>
                      }
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className="pt-[8px] flex justify-center">
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={paginationData?.count || 10}
          pageSize={10}
          onPageChange={(page) => {
            setCurrentPage(page);
            getNotificationData(page);
          }}
        />
      </div>
      <ConfrimModal
        show={confrimModalShow}
        onHide={() => setConfrimModalShow(false)}
        onYesClick={handleDeleteConfig}
        heading={"Delete Notification Configration"}
        message={
          "Are you sure you want to delete this Notification Configration?"
        }
      />
    </div>
  );
}

export default NotificationComponent;
